<div class="base-modal">
  <span class="base-modal__close-button" (click)="closeModal()">
    <i class="material-icons"> close </i>
  </span>
  <div class="base-modal__header">
    <h2 class="base-modal__title">Telegram connection</h2>
  </div>

  <form [formGroup]="telegramForm">
    <div class="base-modal__body">
      <div class="brn-form-field">
        <input type="text" formControlName="username" placeholder="Username" />
      </div>
      <div class="brn-form-field">
        <input type="text" formControlName="token" placeholder="Token" />
      </div>
    </div>

    <div class="base-modal__footer">
      <button
        *ngIf="newConnection"
        class="button button--flat"
        (click)="createConnection()"
        [ngClass]="{ 'button--disabled': !validForm }"
      >
        Create connection
        <i *ngIf="pendingStatus" class="material-icons button__loader">
          rotate_right
        </i>
      </button>

      <button
        *ngIf="!newConnection"
        class="button button--flat"
        (click)="updateConnection()"
        [ngClass]="{ 'button--disabled': !validForm }"
      >
        Save changes
        <i *ngIf="pendingStatus" class="material-icons button__loader">
          rotate_right
        </i>
      </button>
      <button
        *ngIf="!newConnection"
        class="button button--flat button--danger"
        (click)="removeConnection()"
      >
        Remove connection
      </button>
    </div>
  </form>
</div>
